module.exports = __webpack_public_path__ + "images/7824050e90f727ce6e69200846d842a7.svg";